import { isMobile, isTablet } from 'mobile-device-detect';

angular.module('deviceDetectorModule', [])

.factory('DeviceDetectorService', function () {
  return {
    isMobile() {
      return isMobile;
    },

    isTablet() {
      return isTablet;
    },

    isDesktop() {
      return !isMobile && !isTablet;
    },
  };
});
